export const CapitalizeFirstWord = (input) => {
  if (typeof input === 'string' && input.length > 0) {
    return input.replace(/(?:^|\s)\S/g, (match) => match.toUpperCase())
  } else {
    return input
  }
}
